import { Request, Response, NextFunction } from 'express';
import * as authService from './auth.service';
import { RegisterSchema, LoginSchema, RefreshSchema } from './auth.schema';
import { AuthRequest } from '../../middleware/auth.middleware';

export async function register(req: Request, res: Response, next: NextFunction) {
  try {
    const dto = RegisterSchema.parse(req.body);
    const user = await authService.registerUser(dto);
    res.status(201).json({ success: true, data: user });
  } catch (err) { next(err); }
}

export async function login(req: Request, res: Response, next: NextFunction) {
  try {
    const dto = LoginSchema.parse(req.body);
    const result = await authService.loginUser(dto, req.headers['user-agent'], req.ip);
    res.json({ success: true, data: result });
  } catch (err) { next(err); }
}

export async function refresh(req: Request, res: Response, next: NextFunction) {
  try {
    const { refreshToken } = RefreshSchema.parse(req.body);
    const tokens = await authService.refreshTokens(refreshToken);
    res.json({ success: true, data: tokens });
  } catch (err) { next(err); }
}

export async function logout(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const token = req.headers.authorization!.substring(7);
    await authService.logoutUser(req.user!.sub, req.body.sessionId ?? '', token);
    res.json({ success: true, message: 'Logged out' });
  } catch (err) { next(err); }
}

export async function me(req: AuthRequest, res: Response, next: NextFunction) {
  try {
    const user = await authService.getMe(req.user!.sub);
    res.json({ success: true, data: user });
  } catch (err) { next(err); }
}
